import { Lounge } from "../types/lounge.entity";

export const loungeStatusStyles: Record<Lounge["status"], string> = {
  STANDBY: "bg-amber-50  text-amber-700  border border-amber-100",
  ACCEPTED: " bg-blue-50   text-blue-700    border border-red-100",
  CANCELLED: " bg-red-50 text-orange-700 border border-orange-100",
  EXPIRED: "bg-orange-50  text-green-700  border border-green-100",
};

export const loungeInitiatorType: Record<Lounge["initiatorType"], string> = {
  COACH: "bg-blue-100   text-blue-700   border border-blue-100",
  LEARNER: "bg-green-100   text-blue-700   border border-blue-100",
};
